import { CrudEvent } from './logger.crud-event';

export class MetamodelCrudEvent extends CrudEvent {
    constructor(
        actionName: string,
        entityName: string,
        entityType: string,
        concept: string
    ) {
        super(actionName, entityName, entityType, concept, 'MetamodelCrud');
    }
}
